App.SmDatePickerComponent = Em.Component.extend
  classNames: [ 'sm-date-picker' ]
  classNameBindings: [ 'disabled', 'clearButton:with-clear-button', 'notEmpty' ]

  notEmpty:    Ember.computed.notEmpty 'value'
  clearButton: false
  value:       null
  timezone:    null
  dateFormat: 'DD.MM.YYYY'

  dateChanged: (newValue) ->

    value = @get('value')
    mv = if value then moment(value) else moment()

    if !Ember.isEmpty(newValue)
      nw = moment(newValue)
        .hours(   mv.hours() )
        .minutes( mv.minutes() )
        .seconds( mv.seconds() )
        .toDate()
    else
      nw = null

    @set('value', nw)
    @sendAction('onChange', nw)

  onValueChanged: (->
    value = @get('value')

    $elem = @$('.date-input')

    if value
      $elem.val( moment(value).format( @get('dateFormat')) )
      @get('pickerInstance')?.setDate( value, true )
    else
      @get('pickerInstance')?.setDate( value, null )
  ).observes('value')


  attachTimePicker: (->
    $elem = @$('.date-input')

    self = @

    picker = new Pikaday
      field:    $elem.get(0)
      format:   @get('dateFormat')
      firstDay: 1
      theme:   'sm-date-picker-calendar'
      onSelect: ->
        date = @getDate()

        if !self || self.get('isDestroyed')
          return

        self.dateChanged(date)          
    @set('pickerInstance', picker)
    @onValueChanged()
  ).on('didInsertElement')

  removeTimePicker: (->
    @get('pickerInstance')?.destroy?()
  ).on('willDestroyElement')

  actions:
    clearField: ->
      @dateChanged null

